export default function () {
  console.log("Lost connection to socket manager");
  this.identified = false;
  this.on = false;
}
